import React from "react";

function Menu() {
  return (
    <>
      <div className="side_menu4_overlay"></div>
      <div className="side_menu4_overlay2"></div>
      <div className="side_menu_style4">
        <div className="content">
          <div className="main_links">
            <ul>
              <li>
                <a href="/home1/" className="main_link">
                  home
                </a>
              </li>
              <li>
                <a href="/innerpages/about" className="main_link">
                  About
                </a>
              </li>
              <li>
                <a href="/innerpages/services" className="main_link">
                  Services
                </a>
              </li>
              <li>
                <a href="#" className="main_link">
                  Portfolio
                  {/* /innerpages/portfolio */}
                </a>
              </li>
              {/* <li>
                <a className="main_link" href="/innerpages/blog">
                  Blog
                </a>
              </li> */}
              <li>
                <a href="#" className="main_link">
                  contact
                </a>
              </li>
            </ul>
          </div>
        </div>
        <img
          src="/home1/assets/img/chat_pat2.png"
          alt=""
          className="side_shape"
        />
        <img
          src="/home1/assets/img/chat_pat2.png"
          alt=""
          className="side_shape2"
        />
        <span className="clss">
          <i className="la  la-times"></i>
        </span>
      </div>
    </>
  );
}

export default Menu;
